// src/services/api/pageConfigApi.ts
import { apiClient } from './apiClient';
import type { PageConfig, UploadedFont } from '../../types/page-config';
import type { ProjectId } from '../../context/ProjectContext';

export const pageConfigApi = {
  async get(project: ProjectId, locale = 'en'): Promise<PageConfig> {
    const res = await apiClient.get(`/api/${project}/${locale}/pageconfig`);
    return res.data as PageConfig;
  },

  async update(
    project: ProjectId,
    locale: string,
    config: PageConfig,
  ): Promise<PageConfig> {
    const res = await apiClient.put(
      `/api/${project}/${locale}/pageconfig`,
      config,
    );
    return res.data as PageConfig;
  },

  async listFonts(): Promise<UploadedFont[]> {
    const res = await apiClient.get('/api/fonts');
    return (res.data || []) as UploadedFont[];
  },

  async uploadFont(
    file: File,
    meta: { family: string; weight: number; italic: boolean },
  ): Promise<UploadedFont> {
    const form = new FormData();
    form.append('file', file);
    const params = new URLSearchParams({
      family: meta.family,
      weight: String(meta.weight),
      italic: String(meta.italic),
    });
    const res = await apiClient.post(
      `/api/upload-font?${params.toString()}`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return res.data as UploadedFont;
  },

  async deleteFont(filename: string): Promise<void> {
    await apiClient.delete(`/api/upload-font/${encodeURIComponent(filename)}`);
  },
};
